import { Outlet } from 'react-router-dom'
import { Title } from './contents'
import 'enasops/styles/layout/content.less'

const Content = () => {
  return (
    <div className='content'>
      <Title />
      <div className='content__main'>
        <Outlet />
      </div>
    </div>
  )
}

export default Content